@if (currentView === 'review-chiefsorder') {
  <div class="grid-container full-height full v-pad">
    <div class="user-form-max-width">
      <h2>Review</h2>
      <div class="grid-x grid-margin-x">
        @if (isLoading$ | async) {
          <div class="cell large-12 text-center">
            Generating PDF Preview...
          </div>
        }
        @if (pdfAvailable) {
          <div class="cell large-6 text-align-left">
            <button (click)="previousPage()" class="linkButton" [disabled]="currentPage === 1">
              &laquo; Back
            </button>
          </div>
          <div class="cell large-6 text-align-right">
            <button (click)="nextPage()" class="linkButton" [disabled]="currentPage === totalPages">
              Next &raquo;
            </button>
          </div>
          <!-- PDF -->
          <div class="cell large-12 text-center">
            <ngx-extended-pdf-viewer [src]="pdfUrl" [textLayer]="true" [showAll]="false" [page]="currentPage" [showToolbar]="false" (pdfLoaded)="onLoadComplete($event)" class="display-block border-one-pixel-solid"></ngx-extended-pdf-viewer>
          </div>
          <div class="cell large-6 text-align-left margin-bottom">
            <button (click)="previousPage()" class="linkButton" [disabled]="currentPage === 1">
              &laquo; Back
            </button>
          </div>
          <div class="cell large-6 text-align-right">
            <button (click)="nextPage()" class="linkButton" [disabled]="currentPage === totalPages">
              Next &raquo;
            </button>
          </div>
          <div class="cell large-12 text-left">
            <button (click)="download()" class="button hollow">
              Download <svg-icon icon="icon-download" class="light-blue"></svg-icon>
            </button>
            <a style="display:none" href="" target="_blank" #downloadLink></a>
          </div>
        }
        @if (showError) {
          <div class="cell large-12 text-center">
            Unable to render the PDF.
          </div>
        }
        @if (displayGroupAssignment) {
          <div class="cell small-12"></div>
          <div class="user-form-max-width">
            <h2>Please Choose the group you wish to assign/return review to:</h2>
            <ng-select [(ngModel)]="selectedGroup" [items]="allGroups" bindLabel="displayName" placeholder=""></ng-select>
          </div>
        }
      </div>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          <upload-view-files #files [uniqueId]="'files'" [coInstanceId]="coInstanceId" [isSupplemental]="false" [componentLabel]="'Exhibits:'" [showFileList]="false" [isPadded]="false" (newFilesList)="savedFiles($event)"></upload-view-files>
        </div>
        @if (hasFileListing()) {
          <div class="file-list cell small-12">
            Uploaded Files To Merge Into Letter:
            <div class="margin-bottom">
              @for (fl of filesToShow; track fl) {
                <div class="uploaded-files">
                  <span class="file-name padding-left">{{fl.fileName}}</span>
                  @if (allowFileDeletion) {
                    <button type="button" class="minor-margin-right" attr.aria-label="Delete file'{{fl.fileName}}'"
                      (click)="deleteFile(fl)">
                      <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
                    </button>
                  }
                  <button type="button" attr.aria-label="Download file'{{fl.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile(fl)">
                    <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          <upload-view-files #supplementalFiles [uniqueId]="'supplementalFiles'" [coInstanceId]="coInstanceId" [isSupplemental]="true" [showFileList]="false" [isPadded]="false" (newFilesList)="savedSupplementalFiles($event)"></upload-view-files>
        </div>
        @if (hasSupplementalFileListing()) {
          <div class="file-list cell small-12">
            Uploaded Supplemental Files (Will not be merged into letter):
            <div class="margin-bottom">
              @for (fl of supplementalFilesToShow; track fl) {
                <div class="uploaded-files">
                  <span class="file-name padding-left">{{fl.fileName}}</span>
                  @if (allowFileDeletion) {
                    <button type="button" class="minor-margin-right" attr.aria-label="Delete file'{{fl.fileName}}'"
                      (click)="deleteFile(fl)">
                      <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
                    </button>
                  }
                  <button type="button" attr.aria-label="Download file'{{fl.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile(fl)">
                    <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
        <div class="cell small-12">
          <label for="notesText">Review Notes:</label>
          <textarea id="notesText" [(ngModel)]="notesText" placeholder="Review Note"></textarea>
        </div>
        <div class="cell small-12">
          <div class="checkbox display-inline-block">
            <label class="inline">
              <input type="checkbox" [(ngModel)]="isInternalVal" [checked]="isInternalVal">
              Make Review Note Internal
            </label>
          </div>
        </div>
        <div class="cell small-12">
          <button class="button hollow" (click)="addReviewNote()" [disabled]="notesText===''">Add Note</button>
        </div>
        @if (currentView !== 'cancel' && currentView !== 'return') {
          <div class="cell small-12">
            <button class="next-link vertical-middle" (click)="approveCO()" type="button" [disabled]="notesText !==''">
              <span>{{approveText}}</span>
              <span aria-hidden="true" class="next-link-span">
                <svg-icon icon="icon-chevron-right" class="white" aria-hidden="true"></svg-icon>
              </span>
            </button>
          </div>
        }
        <div class="cell small-12 form-button-group">
          @if (!showRejectButton) {
            <button class="button hollow minor-margin-right" [disabled]="coInstanceId === ''" (click)="goToCancelView()">Cancel Chief's Order</button>
          }
          @if (coreReviewModel.currentLevel.returnToGroup != '' || displayGroupAssignment) {
            <button class="button hollow minor-margin-right" [disabled]="coInstanceId === '' " (click)="goToReturnView()">Return</button>
          }
          @if ( coInstanceId === '' || coreReviewModel.currentLevel.mode != 'initiator') {
            <button class="button hollow" (click)="toggleConfirmEditTextDialogue()">Edit Letter</button>
            }&nbsp;
            @if (showRejectButton) {
              <button class="button hollow" (click)="rejectCO()">Reject</button>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (currentView === 'edit-letter') {
    <co-edit-letter [coInstanceId]="coInstanceId" [coreReviewModel]="coreReviewModel" (setCurrentView)="setCurrentView($event)" (setCoreReviewModel)="setCoreReviewModelLetter($event)"></co-edit-letter>
  }
  @if (currentView === 'cancel') {
    <co-cancel [coInstanceId]="coInstanceId" [coreReviewModel]="coreReviewModel" (setCurrentView)="setCurrentView($event)" (setCoreReviewModel)="setCoreReviewModel($event)"></co-cancel>
  }
  @if (currentView === 'return') {
    <co-return [coInstanceId]="coInstanceId" [coreReviewModel]="coreReviewModel" [userSelectedReturnGroup]="selectedGroup" (setCurrentView)="setCurrentView($event)" (setCoreReviewModel)="setCoreReviewModel($event)"></co-return>
  }